import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';
import { ILocationMySuffix } from 'src/app/shared/model/location-mysuffix.model';
import { IStorageRuleMySuffix } from 'src/app/shared/model/storage-rule-mysuffix.model';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { IPackingTypeMySuffix } from './../../shared/model/packing-type-my-suffix.model';




type EntityResponseType = HttpResponse<IStorageRuleMySuffix>;
type EntityArrayResponseType = HttpResponse<IStorageRuleMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class StorageRuleMySuffixService {

    private resourceUrl = SERVER_API_URL + 'api/storage-rules';
    private notifyUsers = SERVER_API_URL + 'api/storage-rules-nortify-users';
    constructor(private http: HttpClient) { }

    create(rule: IStorageRuleMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(rule);
        return this.http
            .post<IStorageRuleMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    update(rule: IStorageRuleMySuffix): Observable<EntityResponseType> {
        const copy = this.convertDateFromClient(rule);
        return this.http
            .put<IStorageRuleMySuffix>(this.resourceUrl, copy, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IStorageRuleMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    

    findForEdit(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IStorageRuleMySuffix>(`${this.resourceUrl + '-edit'}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    findLocations(id: number): Observable<HttpResponse<ILocationMySuffix[]>> {
        return this.http
            .get<ILocationMySuffix[]>(`${this.resourceUrl + '-locations'}/${id}`, { observe: 'response' });

    }


    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http
            .get<IStorageRuleMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' })
            .map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res));
    }

    

    queryForNextDeclartionDate(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
     let url =   this.resourceUrl + '/next-declaration-dates';
        return this.http
            .get<any[]>(url, { params: options, observe: 'response' });
    }


    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    private convertDateFromClient(rule: IStorageRuleMySuffix): IStorageRuleMySuffix {
        const copy: IStorageRuleMySuffix = Object.assign({}, rule, {
            inceptionDate: rule.inceptionDate != null && rule.inceptionDate.isValid() ? rule.inceptionDate.toJSON() : null,
            expiryDate: rule.expiryDate != null && rule.expiryDate.isValid() ? rule.expiryDate.toJSON() : null
        });
        return copy;
    }

    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        res.body.inceptionDate = res.body.inceptionDate != null ? moment(res.body.inceptionDate) : null;
        res.body.expiryDate = res.body.expiryDate != null ? moment(res.body.expiryDate) : null;
        return res;
    }

    private convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
        res.body.forEach((rule: IStorageRuleMySuffix) => {
            rule.inceptionDate = rule.inceptionDate != null ? moment(rule.inceptionDate) : null;
            rule.expiryDate = rule.expiryDate != null ? moment(rule.expiryDate) : null;
        });
        return res;
    }

    findPolicyClientAndInternalstaffUsersByScopeId(scopeId: number): Observable<any> {
        return this.http.get<any>(this.notifyUsers + '/' + scopeId, { observe: 'response' }).map((res: EntityResponseType) => res);
    }
    queryForActivePackingType(req?: any): Observable<HttpResponse<IPackingTypeMySuffix[]>> {
        const options = createRequestOption(req);
        return this.http.get<IPackingTypeMySuffix[]>(SERVER_API_URL + 'api/packing-types' + '-active', { params: options, observe: 'response' });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IStorageRuleMySuffix>(`${this.resourceUrl + '-edit'}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    get(url: string): Observable<any> {
        return this.http.get<any>(SERVER_API_URL+url, { observe: 'response' });
    }
    getByUrl(url?: any): Observable<any> {
        return this.http.get<any>(SERVER_API_URL  + url, { observe: 'response' });
    }


    getPolicyClientWithInternalStaff(scopeId){
        return this.findPolicyClientAndInternalstaffUsersByScopeId(scopeId);
    }

    getByLocationId(id?: any, scopeId?: any): Observable<any> {
        return this.http.get<any>(this.resourceUrl+"/" +id +"/"+ scopeId, { observe: 'response' });
    }

}
